import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
} from "@angular/core";
import {
  UntypedFormBuilder,
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { FileUploadComponent } from "src/app/shared/components/file-upload/file-upload.component";
import { FilesService } from "src/app/core/services/files.service";
import { UsuariosService } from "src/app/core/services/usuarios.service";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { onlyLettersValidator } from "src/app/validators/only-letters.validator";
import { CertificadoService } from "src/app/core/services/certificado.service";
import { SignatureSizeService } from "src/app/core/services/signature-size.service";
import { AuthService } from "src/app/core/services/AuthService";
import { RolesService } from "src/app/core/services/roles.service";
import { PermisosModalComponent } from "src/app/shared/components/permisos-acceso/permisos-modal.component";
import { k } from "src/environments/properties";
import { UsuariosRolesService } from "src/app/core/services/usuarios-roles.service";

interface Item {
  id_user?: string;
  usuario: string;
  correo: string;
  estado: string;
  urlImagenFirma?: string;
  is2fa?: boolean;
}

type ImageSource =
  | File
  | {
      buffer: ArrayBuffer | Uint8Array;
      mime?: string;
      name?: string;
    };

@Component({
  selector: "app-create-user",
  templateUrl: "./create-user.component.html",
  styleUrls: ["./create-user.component.scss"],
})
export class CreateUserComponent implements OnInit {
  fullData: Item[] = []; // Tu conjunto completo de datos
  currentItems: Item[] = []; // Los datos para la página actual

  currentPage: number = 1;
  pageSize: number = 10; // Tamaño de página inicial
  totalItems: number = 0;
  spinner: boolean;

  tableHeaders = [
    { key: "usuario", label: "Usuario" },
    { key: "nombre", label: "Nombre" },
    { key: "correo", label: "Correo" },
    { key: "estado", label: "Estado" },
  ];

  // Definición de las acciones personalizadas
  customActions: TableAction[] = [];

  //Manejo de grupos del usuario
  idGroup: string;
  isLdap: boolean = false;
  public userArrayExcluir: string[] = [];
  public arrayIdUserGroup: string[] = [];

  //MODAL
  public closeResult: string;
  @ViewChild("createUser") referencecreateUser!: TemplateRef<any>;
  @ViewChild("userGroupsModal") userGroupsModal!: TemplateRef<any>;
  @ViewChild("userRolesAndPermissions")
  userRolesAndPermissionsModal!: TemplateRef<any>;
  @ViewChild("resetPasswordModal") resetPasswordModal!: TemplateRef<any>;
  @ViewChild("imagenModalFirma") imagenModalFirma!: TemplateRef<any>;
  @ViewChild("fileUpload", { static: false })
  fileUploadComponent?: FileUploadComponent;

  title = "";
  userForm!: FormGroup;
  rolForm!: FormGroup;
  restoreForm!: FormGroup;

  addUser: boolean = false;
  udpUser: boolean = false;
  idUser: string;

  importUsersForm: FormGroup;
  searchForm: FormGroup;

  certificados: any[];
  userId: any;

  certificadoId: any;

  gruposUsuario: any[];

  roles: any[];
  rolesUsuario: any[];

  // Toast
  toast = Swal;

  restoreEmail: string;
  loadingResetPassword: boolean = false;

  selectedFiles: File | File[] | FileList | null = null;
  imagenFirma: string;
  imagenUrl: string;
  scaled: any;
  firmaCustom: boolean = false;
  existeImagen: boolean = false;
  formSignatureSize: FormGroup;
  accesUser: boolean = false;
  user: any;

  @Input() isEditable: boolean = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private usuarioService: UsuariosService,
    private certificadoService: CertificadoService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private rolesService: RolesService,
    private usuarioRolService: UsuariosRolesService,
    private signatureSizeService: SignatureSizeService,
    private authService: AuthService,
    private filesService: FilesService,
  ) {
    this.user = localStorage.getItem(k.user_id) ?? "";
  }

  async ngOnInit() {
    this.accesUser = this.authService.hasRoleAuth("ADMINISTRADOR");
    this.initUserForm();
    this.initSearchForm();
    this.toastAlert();
    this.getUser();
    this.getRoles();

    // Configura las acciones personalizadas
    this.customActions = [
      {
        label: "Editar",
        handler: (item: Item) => this.showUser(item.id_user),
        icon: "fa-solid fa-pen-to-square",
        colorClass: "bg-orange",
      },
      {
        label: "Eliminar usuario",
        handler: (item: Item) => this.eliminarUsuario(item.id_user),
        icon: "fa fa-trash",
        colorClass: "bg-red",
      },
      /*
      {
        label: 'Grupos',
        handler: (item: Item) => {
          this.idUser = item.id_user;
          this.certificados = [];
          this.gruposUsuario = [];
          this.certificadoId = null
          this.getCertificates(item.id_user);
          this.openModalContent(this.userGroupsModal);
        },
        icon: 'fa fa-users',
        colorClass: 'bg-blue',
      },
      */
      {
        label: "Roles",
        handler: async (item: Item) => {
          this.userId = item.id_user;
          await this.getRolesUsuarios(item.id_user);

          this.openModalContent(this.userRolesAndPermissionsModal);
        },
        icon: "fa fa-key",
        colorClass: "bg-info",
      },
      {
        label: "Reestablecer contraseña",
        handler: async (item: Item) => {
          this.restoreEmail = item.correo;

          this.restoreForm.patchValue({
            email: item.correo,
          });
          this.openModalContent(this.resetPasswordModal);
        },
        icon: "fa fa-unlock",
        colorClass: "bg-warning",
      },
      {
        label: "Resetear doble factor",
        handler: (item: Item) => this.SecondFactor(item.id_user),
        icon: "fa fa-toggle-on",
        colorClass: " text-white bg-success",
        visible: (item: Item) => item.is2fa === true,
      },
      {
        label: "Subir Imagen Firma",
        handler: (item: Item) => {
          this.firmaCustom = false;
          this.userId = item.id_user;

          if (item.urlImagenFirma) {
            this.imagenFirma = item.urlImagenFirma;
            this.existeImagen = true;
            this.showImageFirma();
          } else {
            this.existeImagen = false;
            this.imagenFirma = item.usuario + "-imagen-firma.png";
            this.imagenUrl = "assets/images/not_image.jpg";
          }
          this.openModalContent(this.imagenModalFirma);
        },
        icon: "fa-solid fa-upload",
        colorClass: "bg-orange",
      },
      {
        label: "Gestionar Acceso",
        handler: (item: Item) => this.gestionarAcceso(item.id_user),
        icon: "fa-solid fa-lock",
        colorClass: "bg-blue",
        visible: (item: Item) => {
          return item && this.authService.canManageItem(item, this.accesUser);
        },
      },
    ];
  }

  async groupChange(content: any) {
    this.idGroup = content;

    if (!this.idGroup) {
      this.userArrayExcluir = [];
      this.arrayIdUserGroup = [];
      this.currentItems = [];
      this.totalItems = 0;
    }
  }

  async seleccionarCertificado(id: any) {
    this.certificadoId = id;
    this.getGruposUsuarioCeritificado({
      id_certificado: this.certificadoId,
      id_usuario: this.idUser,
    });
  }

  async getCertificates(userId: any) {
    let certificadosList = await lastValueFrom(
      this.certificadoService.getCertificados(userId),
    );
    if (certificadosList?.body) {
      this.certificados = certificadosList?.body;
    }
  }

  async getGruposUsuarioCeritificado(data: any) {
    let response = await lastValueFrom(
      this.usuarioService.getUserGroupsByCertificate(data),
    );
    if (response?.body) {
      this.gruposUsuario = response?.body;
    }
  }

  async getUserGroup() {
    this.spinner = true;
    this.userArrayExcluir = [];
    this.arrayIdUserGroup = [];
    let params = new HttpParams();
    params = params
      .set("page", this.currentPage)
      .set("limit", this.pageSize)
      .set("pagination", true)
      .set("id_grupo", String(this.idGroup));
    const result = await lastValueFrom(this.usuarioService.userGroups(params));
    this.spinner = false;
    const headers: HttpHeaders = result.headers;
    this.currentItems = result.body.map((x: any, index: number) => {
      return {
        id_usuario_grupo: x.id,
        grupo: x.grupo.nombre,
        nombre: x.usuario.firstName + " " + x.usuario.lastName,
        correo: x.usuario.email,
        urlImagenFirma: x.urlImagenFirma,
      };
    });

    this.totalItems = Number(headers.get("X-Total-Count"));
  }

  async asignarUsuarioGrupo() {
    if (!this.idUser) {
      Swal.fire({
        title: "Usuario requerido!",
        text: "El usuario es requerido para realizar esta acción",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else if (!this.idGroup) {
      Swal.fire({
        title: "Grupo requerido!",
        text: "El grupo es requerido para realizar esta acción",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else if (!this.certificadoId) {
      Swal.fire({
        title: "Certificado requerido!",
        text: "El certificado es requerido para realizar esta acción",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else {
      //Se agrega nuevo certificado al usuario
      await lastValueFrom(
        this.usuarioService.asignUserGroup({
          id_usuario: this.idUser,
          id_grupo: this.idGroup,
          id_certificado: this.certificadoId,
        }),
      );

      // Se listan los certificados del usuario
      this.getGruposUsuarioCeritificado({
        id_certificado: this.certificadoId,
        id_usuario: this.idUser,
      });
    }
  }

  initSearchForm(): void {
    this.searchForm = this.fb.group({
      search: ["", [Validators.required]],
    });
  }

  initUserForm(): void {
    this.userForm = this.fb.group({
      username: [
        "",
        [Validators.required, Validators.minLength(3), onlyLettersValidator()],
      ],
      firstName: [
        "",
        [Validators.required, Validators.minLength(3), onlyLettersValidator()],
      ],
      lastName: [
        "",
        [Validators.required, Validators.minLength(3), onlyLettersValidator()],
      ],
      // password: ["", []], // Ejemplo de longitud mínima
      email: ["", [Validators.required, Validators.email]],
      tipoGrupo: ["", [Validators.required]],
      publica: [false, []],
    });

    this.restoreForm = this.fb.group({
      email: [{ value: "", disabled: true }, Validators.required],
    });

    this.rolForm = this.fb.group({
      rolId: ["", [Validators.required]],
    });

    this.formSignatureSize = this.fb.group({
      id: new FormControl("", []),
      nombre: new FormControl("", [Validators.required]),
      nombre_corto: new FormControl("", [Validators.required]),
      width: new FormControl("", [Validators.required]),
      height: new FormControl("", [Validators.required]),
    });

    this.minusculas();
  }

  minusculas() {
    this.userForm.get("username")?.valueChanges.subscribe((value) => {
      if (value) {
        this.userForm
          .get("username")
          ?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  async getRoles() {
    const result = await lastValueFrom(this.rolesService.getRoles(1, 100));
    if (result?.body) {
      this.roles = result.body;
    }
  }

  async getRolesUsuarios(idUsuario: any) {
    let response = await lastValueFrom(
      this.usuarioService.getUsuario(idUsuario),
    );
    if (response.body.roles) {
      this.rolesUsuario = response.body.roles;
    }
  }

  async asignarRole() {
    if (this.rolForm.valid) {
      let rolId = this.rolForm.value.rolId;
      await lastValueFrom(
        this.usuarioRolService.assignRole(this.userId, rolId),
      );
      this.alert("success", "Rol asignado correctamente");
      await this.getRolesUsuarios(this.userId);
    }
  }

  async deleteRole(rolId: any) {
    Swal.fire({
      title: "¡Eliminación asignación de Rol!",
      text: "¿Deseas eliminar esta asignación de rol?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.usuarioRolService.removeRole(this.userId, rolId),
        );
        await this.getRolesUsuarios(this.userId);
        this.alert("success", "Rol eliminado correctamente");
      }
    });
  }

  async SecondFactor(idUser: any) {
    Swal.fire({
      title: "Confirmación",
      text: "¿Deseas reestablecer el doble factor?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Reestablecer",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.usuarioService.updateUsuario(idUser, {
            mustChange2fa: true,
          }),
        );
        this.alert("success", "Doble factor reestablecido correctamente");
      }
    });
  }

  async searchUser() {
    this.currentPage = 1;
    this.getUser();
  }

  async getUser() {
    this.spinner = true;
    const search = this.searchForm.value.search;
    const result = await lastValueFrom(
      this.usuarioService.getUsuarios(this.currentPage, this.pageSize, search),
    );

    const headers: HttpHeaders = result.headers;
    this.spinner = false;
    this.currentItems = result.body.map((x: any, index: number) => {
      return {
        id_user: x.id,
        nombre: x.firstName + " " + x.lastName,
        usuario: x.username,
        correo: x.email,
        estado: x.isActive == true ? "Activo" : "Inactivo",
        urlImagenFirma: x.urlImagenFirma,
        is2fa: x.is2fa,
      };
    });

    this.totalItems = Number(headers.get("X-Total-Count"));
  }

  async removeAsignacionGrupo(id: any) {
    await lastValueFrom(this.usuarioService.deleteGrupo(id));
    this.getGruposUsuarioCeritificado({
      id_certificado: this.certificadoId,
      id_usuario: this.idUser,
    });
  }

  async CreateUser() {
    const response = await lastValueFrom(
      this.usuarioService.createUsuario(this.userForm.value),
    );

    if (response) {
      this.getUser();
      Swal.fire({
        title: "Creado con éxito",
        text: response.message,
        icon: "success",
        confirmButtonText: "Ok",
      });
      this.modalService.dismissAll();
    }
  }

  async eliminarUsuario(idUsuario: any) {
    Swal.fire({
      title: "¡Eliminar Usuario!",
      text: "¿Deseas eliminar este usuario?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(this.usuarioService.deleteUsuario(idUsuario));
        this.alert("success", "Usuario eliminado correctamente.");
        this.getUser();
      }
    });
  }

  async showUser(id: any) {
    const response = await lastValueFrom(this.usuarioService.getUsuario(id));
    this.openModal(this.referencecreateUser, "edit", "Editar Usuario");
    if (response) {
      this.idUser = response.body.id;
      this.isLdap = response.body.isLdap;

      this.userForm.patchValue({
        username: response.body.username,
        email: response.body.email,
        firstName: response.body.firstName,
        lastName: response.body.lastName,
        tipoGrupo: response.body.tipoGrupo,
        publica: response.body.publica,
      });

      if (this.isLdap) {
        this.userForm.get("tipoGrupo")?.disable();
      } else {
        this.userForm.get("tipoGrupo")?.enable();
      }
    }
  }

  async updateUser() {
    const response = await lastValueFrom(
      this.usuarioService.updateUsuario(this.idUser, this.userForm.value),
    );

    if (response) {
      this.getUser();
      Swal.fire({
        title: "Actualización con éxito",
        text: response.message,
        icon: "success",
        confirmButtonText: "Ok",
      });
      this.modalService.dismissAll();
    }
  }

  /*
   FUNCIONES PARA EL MODAL
  */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  openModalUserHasGroups(content: any, id: any) {
    this.openModalContent(content);
  }

  openModal(content: any, action: string, title: string) {
    this.userForm.reset({ publica: false });
    this.title = title;
    if (action == "add") {
      this.addUser = true;
      this.udpUser = false;
    } else {
      this.addUser = false;
      this.udpUser = true;
    }

    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", size: "lg" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  openModalContent(content: any) {
    this.rolForm.reset();

    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", size: "lg" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  async handleFiles(files: any) {
    this.selectedFiles = files;

    const file: File[] =
      this.selectedFiles instanceof File
        ? [this.selectedFiles]
        : Array.isArray(this.selectedFiles)
          ? this.selectedFiles
          : this.selectedFiles // FileList
            ? Array.from(this.selectedFiles as FileList)
            : [];
    if (file.length > 0) {
      this.existeImagen = true;
      const info: any = await this.loadImageInfo(file[0]);
      this.imagenUrl = info.dataUrl;
      Swal.fire({
        title: "¡Estás subiendo una nueva imagen para firmar!",
        text: "¿Deseas crear un ancho y alto personalizado para tu firma?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.firmaCustom = true;
        }
      });
    }
  }

  getScaleByImageWidth(width: number): number {
    if (width >= 2600) return 0.12; // Gigante
    if (width >= 2200) return 0.14;
    if (width >= 1900) return 0.16;
    if (width >= 1600) return 0.18;
    if (width >= 1400) return 0.2; // Muy grande
    if (width >= 1200) return 0.24;
    if (width >= 1000) return 0.28; // Grande moderada
    if (width >= 850) return 0.32;
    if (width >= 700) return 0.38; // Mediana
    if (width >= 600) return 0.48;
    if (width >= 500) return 0.58;
    if (width >= 400) return 0.7; // Pequeña
    if (width >= 300) return 0.82;
    if (width >= 200) return 0.9;
    return 1; // Muy pequeña (sin reducción)
  }

  getImageSizeCategory(width: number) {
    if (width >= 1600) return "extraLarge";
    if (width >= 1000) return "large";
    if (width >= 600) return "medium";
    if (width >= 350) return "small";
    if (width >= 200) return "extraSmall";
    return "tiny";
  }

  calculateScaledSize(width: number, height: number) {
    const scale = this.getScaleByImageWidth(width).toFixed(2);

    return {
      scale,
      width: Math.round(width * Number(scale)),
      height: Math.round(height * Number(scale)),
    };
  }

  /*ESTA FUNCION QUEDA ASI PARA PODER DETECTAR EL COMPONENTE
  Y PODER LIMPIAR EL UPLOAD QUE SE REDERIZA EN EL MODAL*/
  async subirImagen(fileUpload: FileUploadComponent) {
    const files: File[] =
      this.selectedFiles instanceof File
        ? [this.selectedFiles]
        : Array.isArray(this.selectedFiles)
          ? this.selectedFiles
          : this.selectedFiles // FileList
            ? Array.from(this.selectedFiles as FileList)
            : [];

    if (files.length === 0) {
      this.alert("warning", "Debe seleccionar o arrastrar una imagen");
      return;
    }

    const formData = new FormData();
    files.forEach((f) => formData.append("file", f, f.name));

    if (this.firmaCustom) {
      if (this.formSignatureSize.valid) {
        await this.saveImage(formData);
        await this.saveSignatureSize();
      }
    } else {
      await this.saveImage(formData);
    }

    await this.showImageFirma();
    this.alert("success", "Imagen cargada correctamente");
    fileUpload.clearFiles();
  }

  async saveImage(formData) {
    await lastValueFrom(
      this.usuarioService.subidaImagen(this.userId, formData),
    );
  }

  async saveSignatureSize() {
    const { id, ...payload } = this.formSignatureSize.value;
    await lastValueFrom(this.signatureSizeService.create(payload, true));
  }

  async showImageFirma() {
    let params = new HttpParams().set("disk", "local");

    const result = await lastValueFrom(
      this.filesService.verImagenFirma(this.imagenFirma, params),
    );
    // result.body.data podría ser un array de números o un ArrayBuffer
    const rawBuffer = result.body.data;

    const u8 =
      rawBuffer instanceof Uint8Array ? rawBuffer : new Uint8Array(rawBuffer);

    // 👉 Usa la MISMA función para sacar ancho/alto desde buffer
    try {
      const info: any = await this.loadImageInfo({
        buffer: u8,
        mime: "image/png", // si sabes el tipo, mejor
        name: "firma-backend",
      });

      // Si quieres usar su propio dataUrl:
      this.imagenUrl = info.dataUrl;
    } catch (error) {
      console.error("Error en loadImageInfo (buffer): ", error);
    }
  }

  getDisplayMime(mime: string) {
    if (!mime) return "";
    return mime.split("/");
  }

  private guessMimeFromBuffer(u8: Uint8Array): string {
    if (u8[0] === 0x89 && u8[1] === 0x50) return "image/png";
    if (u8[0] === 0xff && u8[1] === 0xd8) return "image/jpeg";
    if (u8[0] === 0x47 && u8[1] === 0x49) return "image/gif";
    return "application/octet-stream";
  }

  loadImageInfo(source: ImageSource) {
    return new Promise((resolve, reject) => {
      let mime = "application/octet-stream";
      let name: string | undefined;
      let size: number | undefined;

      // --------- CASO 1: File ---------
      if (source instanceof File) {
        const file = source;

        mime = file.type || "application/octet-stream";
        name = file.name;
        size = file.size;

        const reader = new FileReader();

        reader.onload = (e: any) => {
          const dataUrl = e.target.result as string;
          const img = new Image();

          img.onload = () => {
            const width = img.width;
            const height = img.height;

            // tu cálculo de escala
            this.scaled = this.calculateScaledSize(width, height);
            this.formSignatureSize.patchValue({
              nombre_corto: this.getImageSizeCategory(this.scaled.width),
              width: this.scaled.width,
              height: this.scaled.height,
            });
            resolve({
              width,
              height,
              mime,
              name,
              size,
              dataUrl: dataUrl,
            });
          };

          img.onerror = (err) => reject(err);
          img.src = dataUrl;
        };

        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);

        return;
      }

      // --------- CASO 2: Buffer ---------
      let u8: Uint8Array;

      if (source.buffer instanceof Uint8Array) {
        u8 = source.buffer as Uint8Array;
      } else {
        u8 = new Uint8Array(source.buffer as ArrayBuffer);
      }

      mime = source.mime || this.guessMimeFromBuffer(u8);
      name = source.name;
      size = u8.byteLength;

      // Usamos el buffer interno como BlobPart para evitar el error de tipos
      const blob = new Blob([u8.buffer as ArrayBuffer], { type: mime });
      const objectUrl = URL.createObjectURL(blob);

      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;

        // si también quieres escalar cuando viene de buffer:
        this.scaled = this.calculateScaledSize(width, height);
        this.formSignatureSize.patchValue({
          nombre_corto: this.getImageSizeCategory(this.scaled.width),
          width: this.scaled.width,
          height: this.scaled.height,
        });

        const reader = new FileReader();
        reader.onload = (e: any) => {
          const dataUrl = e.target.result as string;

          resolve({
            width,
            height,
            mime,
            name,
            size,
            dataUrl,
          });

          URL.revokeObjectURL(objectUrl);
        };

        reader.readAsDataURL(blob);
      };

      img.onerror = (err) => {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      };

      img.src = objectUrl;
    });
  }

  getStyleString(scaleData: { width: number; height: number }) {
    return `
    width: ${scaleData.width}px;
    height: ${scaleData.height}px;
    border: 2px solid #2196F3;
    border-radius: 6px;
    display: inline-block;
  `;
  }

  getStyleContenedorImg(scaleData: { width: number; height: number }) {
    return `
    width: ${scaleData.width}px;
    height: ${scaleData.height}px;
    text-align: center;
    margin-bottom: 2%;
  `;
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getUser();
  }

  onPageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
    this.getUser();
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }

  async sendRecoverPasswordRequest() {
    if (!this.restoreEmail) {
      Swal.fire({
        title: "¡Campo requerido!",
        text: "El campo de correo o usuario es requerido",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }

    const userNameOrEmail: string = this.restoreEmail.trim();

    if (!userNameOrEmail) {
      Swal.fire({
        title: "¡Campo requerido!",
        text: "El campo de correo o usuario es requerido",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      this.loadingResetPassword = true;
      const responseRestorePassword = await lastValueFrom(
        this.usuarioService.resetPassword(userNameOrEmail),
      );
      Swal.fire({
        title: "Correo enviado",
        text:
          responseRestorePassword?.message ??
          "Se ha enviado el correo de recuperación.",
        icon: "success",
        confirmButtonText: "Ok",
      });

      this.modalService.dismissAll();
    } catch (error: any) {
      const backendMessage =
        error?.error?.message ||
        "No se pudo enviar el correo de recuperación. Intente nuevamente.";
      Swal.fire({
        title: "Error",
        text: backendMessage,
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      this.loadingResetPassword = false;
    }
  }

  async gestionarAcceso(id: any) {
    const modalRef = this.modalService.open(PermisosModalComponent, {
      centered: true,
      size: "xl",
    });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.modeloAcceso = "Usuario";
  }
}
